// Formatting for robots.lastRunAt — when a bot's most recent navigation or
// patrol ended. Shared rather than inlined per page for the same reason
// battery.js is: the existing hand-rolled timeAgo copies drifted into three
// different output formats.

// null means no run recorded since the field shipped, NOT "never ran" — we
// cannot distinguish those, so callers render a dash and claim neither.
const parse = (value) => {
  if (!value) return null;
  const then = new Date(value);
  return Number.isNaN(then.getTime()) ? null : then;
};

/** Compact relative age: "Just now", "5m ago", "3h ago", "12d ago". */
export const lastRunRelative = (value, now = Date.now()) => {
  const then = parse(value);
  if (!then) return null;

  // Clamped: a robot whose clock runs ahead of the server would otherwise
  // render "in 3 minutes" for a run that has already finished.
  const minutes = Math.floor(Math.max(0, now - then.getTime()) / 60000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

/** Full timestamp, for the tooltip/secondary line behind the relative age. */
export const lastRunExact = (value) => {
  const then = parse(value);
  if (!then) return null;
  return then.toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
